import React, { useState } from "react";
import { OPContainer, OPBox, OPWrapper } from "../settings/SettingsStyled";
import {
  BallContainer,
  Ball,
  Header,
  Button,
  OuterDiv,
} from "./SelectMinesStyled";

export default ({
  handleAbove,
  handleBombs,
  bombs,
  saveMines,
  aboveAnim,
  handleAboveAnim,
  audio
}) => {
  const [setA, setSetA] = useState(false);

  const [soundPlayed, setSoundPlayed] = useState(false);

  const minesq = () => {
    let b = [];
    for (let i = 1; i < 25; i++) {
      b.push(i);
    }
    return b;
  };

  const setMines = (e) => {
    saveMines(e);
    handleAbove(false);
  };
  const setAnimation = (a, b) => {
    if (a) {
      b(false);
      clearTimeout();
    } else {
      b(true);
      setTimeout(() => {
        b(false);
      }, 500);
    }
  };

  return (
    <OPContainer aboveAnim={aboveAnim}>
      <OPWrapper>
        <OPBox aboveAnim={aboveAnim}>
          <OuterDiv>
            <>
              <Header>
                <p>Number Of Mines</p>
              </Header>
              <BallContainer>
                {minesq().map((mine) => (
                  <Ball
                    className={mine === parseInt(bombs) && "selected"}
                    key={mine}
                    onClick={() => {
                      mine !== parseInt(bombs) && audio.switch();
                      handleBombs(mine);
                    }}
                  >
                    <p>{mine}</p>
                    <span />
                  </Ball>
                ))}
              </BallContainer>
            </>
            <Button
              setA={setA}
              isDisabled={soundPlayed}
              onClick={() => {
                setAnimation(setA, setSetA);
                audio.confirm();
                setSoundPlayed(true);
                setTimeout(() => {
                  handleAboveAnim(false);
                  setTimeout(() => {
                    setMines(bombs);
                  }, 500);
                }, 100);
              }}
            >
              ok
            </Button>
          </OuterDiv>
        </OPBox>
      </OPWrapper>
    </OPContainer>
  );
};
